import type { CommandData } from '../types'

export function toggle() {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'toggle',
  }
  window.postMessage(message)
}
